import colors from 'fincraft-lib-basics/src/js/colors'

//TODO better formatutils
const round = function(num){
  return Math.round((num + Number.EPSILON) * 100) / 100
}

export default function (H) {
  H.addEvent(H.Chart, 'render', function(e) {
    const chart = e.target
    chart.yAxis.forEach(axis => {
      const {dataMin, dataMax} = axis.getExtremes()

      axis.removePlotLine() //TODO remove by id
      if (dataMin !== dataMax) {
        if (axis.options.showExtremes?.max) {
          axis.addPlotLine({
            value: dataMax,
            color: 'green',
            dashStyle: 'shortdash',
            width: 1,
            label: {
              text: round(dataMax),
              style: {
                color: colors["soft-green"]
              },
              id: 'plotlinemax',
              x: 30
            }
          })
        }
        if (axis.options.showExtremes?.min) {
          axis.addPlotLine({
            value: dataMin,
            color: 'red',
            dashStyle: 'shortdash',
            width: 1,
            label: {
              text: round(dataMin),
              style: {
                color: colors["pale-red"]
              },
              id: 'plotlinemin',
              x: 30,
              y: 15
            }
          })
        }
      }
    })
  })
}
